const railOuterStyle = {
  position: "absolute",
  width: "100%",
  height: 42,
  transform: "translate(0%, -50%)",
  borderRadius: 7,
  cursor: "pointer",
  // border: '1px solid white',
};

const railInnerStyle = {
  position: "absolute",
  width: "100%",
  height: 14,
  transform: "translate(0%, -50%)",
  borderRadius: 7,
  pointerEvents: "none",
  //backgroundColor: "rgb(155,155,155)",
};

export function SliderRail({ getRailProps }) {
  return (
    <>
      <div className="slidercomponents" style={railOuterStyle} {...getRailProps()} />
      <div className="slidercomponents1" style={railInnerStyle} />
    </>
  );
}

export function Handle({
  domain: [min, max],
  handle: { id, value, percent },
  disabled,
  getHandleProps,
}) {
  return (
    <>
      <div
        className="slidercomponents2"
        style={{
          left: `${percent}%`,
          WebkitTapHighlightColor: "rgba(0,0,0,0)",
          // border: '1px solid white',
        }}
        {...getHandleProps(id)}
      />
      <div
        role="slider"
        aria-valuemin={min}
        aria-valuemax={max}
        aria-valuenow={value}
        className="slidercomponents3"
        style={{
          left: `${percent}%`,
        }}
      />
    </>
  );
}

export function Track({ source, target, getTrackProps, disabled }) {
  return (
    <div
      className="slidercomponents4"
      style={{
        left: `${source.percent}%`,
        width: `${target.percent - source.percent}%`,
      }}
      {...getTrackProps()}
    />
  );
}
